import { useMediaQuery } from 'react-responsive'
import constants from '../helpers/constants'

function useResponsive() {
  const isTablet = useMediaQuery(constants.tabletConfig)
  const isDesktop = useMediaQuery(constants.desktopConfig)
  const isMobile = useMediaQuery(constants.mobileConfig)

  return {
    isTablet, isMobile, isDesktop
  }
}

export default useResponsive